import {
  AutoComplete,
  Alert,
  Button,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Card,
  Radio,
  Row,
  Select,
  Slider,
  Switch,
  Tooltip,
} from "antd";
import { DeleteOutlined, InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { formatAmount } from "../../utils/utils";
const { Option } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const renderHelpLabel = (label: any, tooltip?: string) => {
  if (!tooltip) return label;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span>{label}</span>
      <Tooltip title={tooltip} trigger={["hover", "click"]}>
        <InfoCircleOutlined style={{ color: "#6b7280", cursor: "pointer" }} />
      </Tooltip>
    </span>
  );
};


export type GenericFormProps = {
  form: any;
  name: string;
  heading?: string;
  subHeading?: any;
  onFinish: any;
  onFinishFailed: any;
  formElements: any;
  initialValues: any;
  setValues?: any;
  extraButtons?: any;
  submitButtonText?: string;
  submitButtonType?: any;
  loading?: boolean;
  onValuesChange?: any;
  enableEnterSubmit?: boolean;
};

const GenericFormComponent: React.FC<GenericFormProps> = ({
  form,
  name,
  heading,
  onFinish,
  onFinishFailed,
  formElements,
  extraButtons,
  submitButtonText,
  initialValues,
  submitButtonType = "primary",
  loading = false,
  subHeading,
  enableEnterSubmit = false,
  onValuesChange = () => {
    return;
  },
  setValues = null,
}: GenericFormProps) => {
  form.setFieldsValue(setValues);

  const finalFormElements = formElements.filter(Boolean);

   

  return (
    <>
      <Form
        form={form}
        initialValues={initialValues}
        name={name}
        className="paddingx20 app-form full-width"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
        {...(enableEnterSubmit
          ? {
              onKeyPress: (e) => {
                if (e.key === "Enter") {
                  form.submit();
                }
              },
            }
          : {})}
      >
        <Row gutter={20} align="bottom" className="cover">
          {finalFormElements.map((ele: any, index: number) => {
            return ele.type === "assetProfileSubSection" ? (
              <>
                <Col span={24}>
                  <Row gutter={20} align="top">
                    <Col span={12}>
                      <Row>
                        {SubSectionElements(1, ele.finalFormElements[0], form)}
                        {SubSectionElements(2, ele.finalFormElements[1], form)}
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row>
                        {SubSectionElements(3, ele.finalFormElements[2], form)}
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </>
            ) : ele.type === "GridData" ? (
              <>
                <GridData ele={ele} />
              </>
            ) : (
              SubSectionElements(index, ele, form)
            );
          })}
        </Row>
        {submitButtonText && submitButtonText !== "" && (
          <Row className="button-row">
            <Col span={24}>
              <Form.Item>
                <Button
                  loading={loading}
                  // size="large"
                  className={"mt20"}
                  type={submitButtonType}
                  htmlType="submit"
                  block
                >
                  {submitButtonText}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        )}
        {extraButtons && (
          <Row className="button-row" justify="end" gutter={16}>
            {extraButtons.map((btn: any, index: number) => {
              return (
                <Col
                  {...btn?.colSpanResponsive}
                  span={btn.colSpan}
                  key={index}
                  className="gutter-row"
                >
                  <Form.Item>
                    <Button
                      loading={btn.loading}
                      // size="large"
                      {...(btn.type === "clearForm"
                        ? {
                            onClick: () => {
                              form.resetFields();
                              btn.onClick?.();
                            },
                          }
                        : btn.onClick
                        ? { onClick: btn.onClick }
                        : {})}
                      className={"mt20"}
                      type={btn.submitButtonType}
                      htmlType={
                        btn.type === "clearForm" ? "button" : btn.htmlType
                      }
                      block
                    >
                      {btn.submitButtonText}
                    </Button>
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        )}
      </Form>
    </>
  );
};

export default GenericFormComponent;


export const SubSectionElements = (index: number, ele: any, form: any) => {
 
  const handleWeightBlur = (
  fieldName: string,
  rawValue: number | null
) => {
  if (rawValue === null || rawValue === undefined) {
    return;
  }

  let value = Number(rawValue);

  if (Number.isNaN(value)) {
    return;
  }

  // 50 -> 0.50
  // 75 -> 0.75
  if (value > 1) {
    value = value / 100;
  }

  value = Number(value.toFixed(2));

  const currentValues = form.getFieldsValue([
    "weightSimilarity",
    "weightRule",
    "weightAi",
  ]);

  const similarity = currentValues.weightSimilarity;
  const rule = currentValues.weightRule;
  const ai = currentValues.weightAi;

  // First entry = all 3 fields are empty
  const isFirstEntry =
    (similarity === undefined ||
      similarity === null ||
      similarity === "") &&
    (rule === undefined ||
      rule === null ||
      rule === "") &&
    (ai === undefined ||
      ai === null ||
      ai === "");

  // ------------------------------------
  // FIRST ENTRY ONLY
  // ------------------------------------
  if (isFirstEntry) {
    const remaining = Number((1 - value).toFixed(2));

    const first = Number(
      (remaining / 2).toFixed(2)
    );

    const second = Number(
      (remaining - first).toFixed(2)
    );

    const values = {
      weightSimilarity:
        fieldName === "weightSimilarity"
          ? value
          : first,

      weightRule:
        fieldName === "weightRule"
          ? value
          : second,

      weightAi:
        fieldName === "weightAi"
          ? value
          : first,
    };

    form.setFieldsValue(values);

    return;
  }

  // ------------------------------------
  // AFTER FIRST ENTRY
  // ONLY CURRENT FIELD
  // ------------------------------------
  form.setFieldsValue({
    [fieldName]: value,
  });
};
  return (
    <Col
      key={index}
      {...ele?.colSpanResponsive}
      span={ele?.colSpan ? ele?.colSpan : 24}
    >
      {(ele.visible === undefined || ele.visible === true) && (
        <Form.Item
          name={
            ele.type === "PrimaryRule" || ele.type === "SecondaryRule"
              ? undefined
              : ele.name
          }
          key={index}
          label={
            ele.type === "TextLabel" || ele.type === "InfoAlert"
              ? undefined
              : renderHelpLabel(ele.label, ele.tooltip)
          }
          rules={
            ele.type === "PrimaryRule" || ele.type === "SecondaryRule"
              ? []
              : ele.rules
              ? ele.rules
              : []
          }
          dependencies={ele.dependencies}
          validateStatus={ele.validateStatus ? ele.validateStatus : undefined}
          help={ele.help ? ele.help : undefined}
          {...(ele.valuePropName ? { valuePropName: ele.valuePropName } : {})}
          {...(ele.type === "CheckBox" ? { valuePropName: "checked" } : {})}
          {...(ele.type === "Checkbox" ? { valuePropName: "checked" } : {})}
          style={
            ele.type === "TextLabel" || ele.type === "InfoAlert"
              ? { marginBottom: ele.type === "InfoAlert" ? 12 : 0 }
              : {}
          }
        >
          {ele.type === "TextLabel" ? (
            <div className="ant-form-item-label">
              <label style={{ display: "unset" }}>
                {renderHelpLabel(ele.textlabel, ele.tooltip)}
              </label>
            </div>
          ) : ele.type === "InfoAlert" ? (
            <Alert
              showIcon
              type={ele.alertType || "warning"}
              message={ele.message}
              description={ele.description}
            />
          ) : ele.type === "Switch" ? (
            <Switch size="small" />
          ) : ele.type === "PrimaryRule" ? (
            <Form.List name={ele.name}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, rowIndex) => (
                    <Row gutter={16} key={field.key} align="top">
                      <Col span={15}>
                        <Form.Item
                          {...field}
                          name={[field.name, "value"]}
                          label={rowIndex === 0 ? "Primary Skills" : undefined}
                          dependencies={["weightRule"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_: any, value: any) {
                                if (Number(getFieldValue("weightRule") || 0) <= 0) {
                                  return Promise.resolve();
                                }
                                return value && String(value).trim()
                                  ? Promise.resolve()
                                  : Promise.reject(new Error("Required"));
                              },
                            }),
                          ]}
                        >
                          <Input placeholder="e.g. Java" />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name={[field.name, "weight"]}
                          label={rowIndex === 0 ? "Rule Weight" : undefined}
                          dependencies={["weightRule"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_: any, value: any) {
                                if (Number(getFieldValue("weightRule") || 0) <= 0) {
                                  return Promise.resolve();
                                }
                                const weight = Number(value);
                                return Number.isFinite(weight) && weight > 0
                                  ? Promise.resolve()
                                  : Promise.reject(new Error("Required"));
                              },
                            }),
                          ]}
                        >
                          <InputNumber
                            min={0}
                            max={1}
                            step={0.01}
                            style={{ width: "100%" }}
                            placeholder="0.5"
                            formatter={(value) =>
                              value === undefined || value === null
                                ? ""
                                : String(Number(value))
                            }
                            parser={(value: any) =>
                              value ? Number(value.replace(/[^\d.]/g, "")) : 0
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        {fields.length > 1 && (
                          <Button
                            type="link"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => remove(field.name)}
                            style={{ marginTop: rowIndex === 0 ? 28 : 0 }}
                            title="Delete primary skill"
                          />
                        )}
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={() => add({ value: "", weight: 0 })}
                    block
                  >
                    Add Primary Skill
                  </Button>
                </>
              )}
            </Form.List>
          ) : ele.type === "SecondaryRule" ? (
            <Form.List name={ele.name}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, rowIndex) => (
                    <Row gutter={16} key={field.key} align="top">
                      <Col span={15}>
                        <Form.Item
                          {...field}
                          name={[field.name, "value"]}
                          label={rowIndex === 0 ? "Secondary Skills" : undefined}
                        >
                          <Input placeholder="e.g. Docker" />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name={[field.name, "weight"]}
                          label={rowIndex === 0 ? "Rule Weight" : undefined}
                        >
                          <InputNumber
                            min={0}
                            max={1}
                            step={0.01}
                            style={{ width: "100%" }}
                            placeholder="0.30"
                            formatter={(value) =>
                              value === undefined || value === null
                                ? ""
                                : String(Number(value))
                            }
                            parser={(value: any) =>
                              value ? Number(value.replace(/[^\d.]/g, "")) : 0
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Button
                          type="link"
                          danger
                          icon={<DeleteOutlined />}
                          onClick={() => remove(field.name)}
                          style={{ marginTop: rowIndex === 0 ? 28 : 0 }}
                          title="Delete secondary skill"
                        />
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={() => add({ value: "", weight: 0 })}
                    block
                  >
                    Add Secondary Skill
                  </Button>
                </>
              )}
            </Form.List>
          )  : ele.type === "Select" ? (
            // ele.mode === "multiple" ? (
            //   <TreeSelect
            //     treeCheckable
            //     showArrow={true}
            //     maxTagCount={0}
            //     maxTagPlaceholder={(omittedValues) => {
            //       return `${omittedValues.length} Selected`;
            //     }}
            //     // size="large"
            //     treeDefaultExpandAll={true}
            //     className="capitalize"
            //     dropdownClassName={
            //       ele?.dropdownClassName ? ele.dropdownClassName : null
            //     }
            //     disabled={ele.disabled}
            //     treeData={ele.options}
            //     onChange={(e) => ele.onChange?.(e)}
            //     placeholder={ele.placeholder ? ele.placeholder : ""}
            //   />
            // )
            // :
            <Select
                 disabled={!!ele.disabled}
                  mode={ele.mode}
                  showSearch={!!ele.showSearch}
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                  (option?.label ?? '')
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={(e) => ele.onChange?.(e)}
                  placeholder={ele.placeholder || ""}
                  allowClear={!!ele.allowClear}
                  >
                 {[...(ele.options || [])]
                .sort((a, b) =>
                   (a.label || a.name || "")
                     .toString()
                    .localeCompare(
                       (b.label || b.name || "").toString(),
                       undefined,
                       {
                         sensitivity: "base",
                       }
                     )
                 )
                  .map((option: any) => (
                  <Option
                    key={option.value ?? option.id}
                    label={option.label || option.name}
                    value={option.value ?? option.id}
                  >
                    {option.label || option.name}
                  </Option>
                  ))}
            </Select>
          ) : ele.type === "DatePicker" ? (
            <DatePicker
              // size="large"
              style={{ width: "100%" }}
              format="DD-MMM-YYYY"
              {...(ele.placeholder ? { placeholder: ele.placeholder } : {})}
              disabledDate={ele.disabledDate ? ele.disabledDate : (_d) => false}
              disabled={ele.disabled ? true : false}
              placeholder={ele.placeholder}
            />
          ) : ele.type === "MonthPicker" ? (
            <DatePicker
              // size="large"
              style={{ width: "100%" }}
              format="MMM, Y"
              picker="month"
              {...(ele.placeholder ? { placeholder: ele.placeholder } : {})}
              disabled={ele.disabled ? true : false}
              placeholder={ele.placeholder}
              disabledDate={ ele?.disabledDate}
            />
          ) : ele.type === "TimePicker" ? (
            <DatePicker.TimePicker
              // size="large"
              style={{ width: "100%" }}
              format="hh:mm A"
              {...(ele.placeholder ? { placeholder: ele.placeholder } : {})}
              disabledDate={ele.disabledDate ? ele.disabledDate : (_d) => false}
              disabled={ele.disabled ? true : false}
              placeholder={ele.placeholder}
            />
          ) : ele.type === "DateTimePicker" ? (
            <DatePicker
              // size="large"
              showNow={false}
              showTime={{ format: "hh:mm A" }}
              disabled={ele.disabled}
              format="MMM DD, Y hh:mm A"
              style={{ width: "100%" }}
              {...(ele.placeholder ? { placeholder: ele.placeholder } : {})}
              disabledDate={ele.disabledDate ? ele.disabledDate : (_d) => false}
            />
          ) : ele.type === "RangePicker" ? (
            <RangePicker
              // size="large"
              style={{ width: "100%" }}
              format="MMM DD, YYYY"
              separator={<span style={{ color: "#999999" }}>to</span>}
              {...(ele.placeholder
                ? {
                    // placeholder: [ele.placeholder[0], ele.placeholder[1]],
                  }
                : {})}
              disabledDate={ele.disabledDate ? ele.disabledDate : (_d) => false}
            />
          ) : ele.type === "SliderRange" ? (
            <Slider range min={ele.min} max={ele.max} />
          ) : ele.type === "Divider" ? (
            <Divider />
          ) : ele.type === "TextArea" ? (
            <TextArea
              {...(ele.showCount ? { showCount: ele.showCount } : {})}
              {...(ele.maxLength ? { maxLength: ele.maxLength } : {})}
              // size="large"
              placeholder={ele.placeholder}
              rows={ele.rows}
              allowClear
            />
          ) : ele.type === "CheckBox" ? (
            <Checkbox disabled={ele.disabled}> {ele.text}</Checkbox>
          ) : ele.type === "Input" ? (
            <Input
              allowClear
              addonAfter={ele.suffix ? ele.suffix : null}
              type={ele.inputType ? ele.inputType : "text"}
              disabled={ele.disabled ? true : false}
              placeholder={ele.placeholder ? ele.placeholder : ""}
              prefix={ele.prefix ? ele.prefix : null}
              maxLength={ele.maxLength}
              {...(ele.fieldProps ? ele.fieldProps : {})}
              {...(ele.onChange ? { onChange: ele.onChange } : {})}
            />
          ) : ele.type === "Button" ? (
            <Button
              // size="large"
              onClick={ele.onClick}
            >
              {ele.name}
            </Button>
          ) : ele.type === "InputNumber" ? (
        <InputNumber
  prefix={ele.prefix || null}
  addonAfter={ele.suffix || null}
  placeholder={ele.placeholder}
  controls={ele.controls}
  style={{ width: "100%" }}
  min={ele.min}
  max={ele.max}
  disabled={!!ele.disabled}
  step={ele.step ?? 0.01}
  precision={2}
  formatter={
    ele.formatter ??
    ((value) =>
      ele.isAmount && value
        ? formatAmount(Number(value))
        : value)
  }
  parser={
    ele.parser ??
    ((value) =>
      ele.isAmount
        ? value?.replace(/[^\d.-]/g, "")
        : value)
  }
  onBlur={(e) => {
    if (!ele.isWeight) return;

    const rawValue = e.target.value;

    if (rawValue === "") return;

    let enteredValue = Number(rawValue);

    if (Number.isNaN(enteredValue)) return;

    // 50 -> 0.50
    // 75 -> 0.75
    if (enteredValue > 1) {
      enteredValue = enteredValue / 100;
    }

    enteredValue = Number(enteredValue.toFixed(2));

    const values = form.getFieldsValue([
      "weightSimilarity",
      "weightRule",
      "weightAi",
    ]);

    const isEmpty = (value: any) =>
      value === undefined ||
      value === null ||
      value === "";

    // Check whether the other two fields are empty
    const otherFields = [
      "weightSimilarity",
      "weightRule",
      "weightAi",
    ].filter((name) => name !== ele.name);

    const isFirstEntry = otherFields.every(
      (name) => isEmpty(values[name])
    );

    // ----------------------------------------
    // FIRST ENTRY ONLY
    // ----------------------------------------
    if (isFirstEntry) {
      const remaining = Number(
        (1 - enteredValue).toFixed(2)
      );

      const firstPart = Number(
        (remaining / 2).toFixed(2)
      );

      const secondPart = Number(
        (remaining - firstPart).toFixed(2)
      );

      const updatedValues: any = {
        weightSimilarity: values.weightSimilarity,
        weightRule: values.weightRule,
        weightAi: values.weightAi,
      };

      // Set entered field
      updatedValues[ele.name] = enteredValue;

      // Distribute remaining value
      const otherFields = [
        "weightSimilarity",
        "weightRule",
        "weightAi",
      ].filter((name) => name !== ele.name);

      updatedValues[otherFields[0]] = firstPart;
      updatedValues[otherFields[1]] = secondPart;

      form.setFieldsValue(updatedValues);

      return;
    }

    // ----------------------------------------
    // AFTER FIRST ENTRY
    // Only update current field
    // ----------------------------------------
    form.setFieldsValue({
      [ele.name]: enteredValue,
    });
  }}
/>
          ) : ele.type === "Cascader" ? (
            <Cascader
              // size="large"
              className={"capitalize"}
              options={ele.data}
              placeholder={"Please Select"}
            />
          ) : ele.type === "Hidden" ? (
            <></>
          ) : ele.type === "Radio" ? (
            <Radio.Group
              // size="large"
              buttonStyle="solid"
              optionType={ele.optionType}
            >
              {ele.options?.map((val: any, i: any) => {
                return (
                  <Radio.Button
                    key={i}
                    className={val.name.toLowerCase()}
                    value={val.value}
                  >
                    {val.name}
                  </Radio.Button>
                );
              })}
            </Radio.Group>
          ) : ele.type === "AutoComplete" ? (
            <AutoComplete
              // size="large"
              dataSource={ele.AutoCompleteData}
              onSearch={ele.onSearch}
              onSelect={ele.onSelect}
              placeholder={ele.placeholder}
            />
          ) : ele.type === "Checkbox" ? (
            <Checkbox disabled={ele.disabled}>{ele.inputLabel}</Checkbox>
          ) : ele.type === "Custom" ? (
            ele.render()
          ) : (
            <></>
          )}
        </Form.Item>
      )}
    </Col>
  );
};

export function GridData({ ele }: any) {
  return (
    <>
      <table style={{ width: "100%" }} className="input-grid-table">
        <thead className="ant-table-thead">
          <tr>
            {ele.titles.map((val: any) => {
              return <th>{val}</th>;
            })}
          </tr>
        </thead>
        <tbody className="ant-table-body">
          {Array(ele.rows)
            .fill(1)
            .map((val: any, index: number) => {
              return (
                <tr>
                  <td>Instalment {index + 1}</td>
                  <td>
                    <Form.Item
                      name={`${ele.elementPrefix}admission_amt_${index}`}
                      rules={[
                        { required: true, message: "Required" },
                        () => ({
                          validator(_: any, value: any) {
                            if (parseInt(value) < 0) {
                              return Promise.reject(new Error("Min 0 Allowed"));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber
                        disabled={ele.rows === index + 1 ? true : false}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={`${ele.elementPrefix}tuition_amt_${index}`}
                      rules={[
                        { required: true, message: "Required" },
                        () => ({
                          validator(_: any, value: any) {
                            if (parseInt(value) < 0) {
                              return Promise.reject(new Error("Min 0 Allowed"));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber
                        disabled={ele.rows === index + 1 ? true : false}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={`${ele.elementPrefix}book_amt_${index}`}
                      rules={[
                        { required: true, message: "Required" },
                        () => ({
                          validator(_: any, value: any) {
                            if (parseInt(value) < 0) {
                              return Promise.reject(new Error("Min 0 Allowed"));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber
                        disabled={ele.rows === index + 1 ? true : false}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={`${ele.elementPrefix}net_amt_${index}`}
                      rules={[
                        { required: true, message: "Required" },
                        () => ({
                          validator(_: any, value: any) {
                            if (parseInt(value) < 0) {
                              return Promise.reject(new Error("Min 0 Allowed"));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber disabled={true} style={{ width: "100%" }} />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={`${ele.elementPrefix}ins_sub_after_day_${index}`}
                      rules={[
                        { required: true, message: "Required" },
                        () => ({
                          validator(_: any, value: any) {
                            if (parseInt(value) < 0) {
                              return Promise.reject(new Error("Min 0 Allowed"));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
